import { graphql, useStaticQuery } from "gatsby"

export type GenesysChatType = {
  domainName: string
  environmentName: string
  deploymentId: string
  enabled?: boolean
}

type Query = {
  GraphCmsSquidex: {
    findGenesysChatSingleton: {
      flatData: GenesysChatType
    }
  }
}

export default function useGenesysChatQuery() {
  const { GraphCmsSquidex } = useStaticQuery<Query>(graphql`
    {
      GraphCmsSquidex {
        findGenesysChatSingleton {
          flatData {
            domainName
            environmentName
            deploymentId
            enabled
          }
        }
      }
    }
  `)

  return GraphCmsSquidex.findGenesysChatSingleton.flatData
}
